

import React, { Fragment } from 'react';


import { Button, Dialog, Grid, } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-scroll';

const LocationMap = ({ maxWidth, button, buttonClass }) => {
  const [open, setOpen] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <i className="ti-close"></i>
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });


  return (
    <Fragment>
      <Button
        className={`btn ${buttonClass}`}
        onClick={handleClickOpen}>
        {button}
        Ver ubicación
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        className="modalWrapper quickview-dialog"
        maxWidth={maxWidth}
      >
        <Grid className="modalBody modal-body">
          <Grid className="modalBody modal-body">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d186.41502077155747!2d-3.7718084189649965!3d37.81560217179443!2m3!1f53.015625!2f54.08548593440413!3f0!3m2!1i1024!2i768!4f35!3m3!1m2!1s0xd6dd6693ca21cf7%3A0xc75f5df31f1b3479!2sHO.%20Ciudad%20de%20Ja%C3%A9n!5e1!3m2!1ses!2ses!4v1737308907584!5m2!1ses!2ses" width="600" height="200" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </Grid>
        </Grid>
        <a
          className="theme-btn"
          href="https://www.google.com/maps/dir//HO.+Ciudad+de+Ja%C3%A9n+km+36-37+Carr.+Bail%C3%A9n-Motril+23009+Ja%C3%A9n/@37.8172104,-3.7687135,19z/data=!4m5!4m4!1m0!1m2!1m1!1s0xd6dd6693ca21cf7:0xc75f5df31f1b3479"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa fa-location-arrow"></i>
          <span style={{ marginLeft: '0.5rem' }}>Cómo llegar</span>
        </a>
        <a
          className="theme-btn  bg-dark"
          href="https://direct-book.com/properties/HOCiudadDeJaenDirect?locale=es&items[0][adults]=2&items[0][children]=0&items[0][infants]=0&currency=EUR&checkInDate=2025-06-20&checkOutDate=2025-06-22&trackPage=yes&promocode=MARIAYCRISTIAN"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa fa-hotel"></i>
          <span style={{ marginLeft: '0.5rem' }}>Reservar  habitacion</span>
        </a>
        {/* <Link onClick={handleClose} className="theme-btn bg-dark" to="hotel" spy={true} smooth={true} duration={500} ><i className="fa fa-hotel"></i>
          <span style={{ marginLeft: '0.5rem' }}>Reservar  habitacion</span></Link> */}
      </Dialog>
    </Fragment>
  );
}
export default LocationMap


